import * as React from "react";
export var SvgContainer = function (_a) {
    var children = _a.children, name = _a.name, SvgComponent = _a.svg;
    return (React.createElement("div", { className: name + "__container" },
        React.createElement(SvgComponent, null),
        React.createElement("div", { className: name + "__container--content" }, children)));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/svg-container/SvgContainer.tsx
// module id = 583
// module chunks = 3